import styled, { css } from 'styled-components'

import { Button } from '../../components/Button'
import { breakpoint, themeSpace } from '../../components/theme'

export const PageTitle = styled.div`
  padding: ${({ theme }) => `${theme.space[4]} 0`};
`

export const SubmitButton = styled(Button)`
  margin-top: ${themeSpace(3)};
  padding: 0 50px;
`
export const PageContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ShapeImage = styled.div`
  display: none;

  ${breakpoint.tablet(css`
    display: block;
  `)}
`
